import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnChanges,
    output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { IContentLanguage } from 'Source/app/shared/fi-content-language-shared/fi-content-language-shared';
import { TemplateLayoutModel } from '@fi-app/template/template-layout.model';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';

@Component({
    selector: 'fi-document-language-selector',
    templateUrl: './document-language-selector.component.html',
    styleUrl: './document-language-selector.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-document-language-selector' },
    standalone: false,
})
export class DocumentLanguageSelectorComponent implements OnChanges {
    @Input({ required: true }) templateLayout: TemplateLayoutModel;
    @Input({ required: true }) hasEditAccessToDocument: boolean;
    @Input({ required: true }) languageId: FiApplicationLanguageType;
    languageIdChange = output<FiApplicationLanguageType>();

    protected documentLanguages: IContentLanguage[] = [];
    protected selectedLanguageName: string = '';

    private templateLayoutLanguageService = inject(TemplateLayoutLanguageService);
    private fiContentLanguageSharedService = inject(FiContentLanguageSharedService);
    private customerDataService = inject(FiCustomerDataService);

    ngOnChanges(changes: SimpleChanges): void {
        const change = changes.templateLayout;
        if (change && change.currentValue) {
            this.setDocumentLanguagesData();
        }
    }

    private setDocumentLanguagesData() {
        const langIds: number[] = this.templateLayoutLanguageService.GetLayoutLanguages(this.templateLayout);
        this.documentLanguages = this.fiContentLanguageSharedService
            .getContentLanguages()
            .filter((lang: IContentLanguage) => langIds.indexOf(lang.Id) > -1);
        this.selectedLanguageNameUpdate();
    }

    private selectedLanguageNameUpdate() {
        const currentContentLanguage: IContentLanguage = this.documentLanguages.find((lang: IContentLanguage) => {
            return this.isLanguageSelected(lang);
        });
        this.selectedLanguageName = currentContentLanguage ? currentContentLanguage.Name : '';
    }

    protected selectLanguage(lang: IContentLanguage) {
        this.languageId = lang.Id;
        this.selectedLanguageNameUpdate();
        this.languageIdChange.emit(lang.Id);
    }

    protected isLanguageSelected(lang: IContentLanguage): boolean {
        return this.languageId === lang.Id;
    }

    protected isSelectLanguagesAvailable() {
        return !this.customerDataService.customerData.UseDefaultContentLanguage || this.hasEditAccessToDocument;
    }
}
